var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon5Card3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.318 8.59375L11.328 14.2778C11.3393 14.3447 11.3299 14.4135 11.301 14.4749C11.2722 14.5364 11.2253 14.5875 11.1666 14.6216C11.1079 14.6557 11.0402 14.671 10.9725 14.6656C10.9048 14.6601 10.8405 14.6341 10.788 14.5911L8.40129 12.7997C8.28607 12.7137 8.14611 12.6672 8.00229 12.6672C7.85847 12.6672 7.71851 12.7137 7.60329 12.7997L5.21262 14.5904C5.16017 14.6334 5.09586 14.6593 5.02829 14.6648C4.96071 14.6702 4.89307 14.655 4.8344 14.621C4.77573 14.587 4.72881 14.536 4.6999 14.4746C4.671 14.4133 4.66148 14.3446 4.67262 14.2778L5.68196 8.59375",
    stroke: "#6A7282",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.33301C10.2091 9.33301 12 7.54215 12 5.33301C12 3.12387 10.2091 1.33301 8 1.33301C5.79086 1.33301 4 3.12387 4 5.33301C4 7.54215 5.79086 9.33301 8 9.33301Z",
    stroke: "#6A7282",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5Card3);
export default __webpack_public_path__ + "static/media/Icon5card3.4a45bee6df958d2778dad3a1a6fe0d04.svg";
export { ForwardRef as ReactComponent };